import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root"
})
export class AgenciaService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getAllAgencia(idAgencia): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_AGENCIA + "/" + idAgencia;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Agencias",
            text: "Error Cargando Agencias.",
            type: "error"
          });
        }
        return throwError(err);
      })
    );
  }

  public getAgencia(idUsuario, idAgencia): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_AGENCIA +
      "/" +
      idUsuario +
      "/" +
      idAgencia;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Agencias",
            text: "Error Cargando Agencias.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public postAgencia(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_AGENCIA;
    return this.http.post<any>(url, params).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Agencias",
            text: "Verifique la informacion ingresada.",
            type: "error",
            confirmButtonColor: "#127570"
          });
        }
        
        return throwError(err);
      })
    );
  }

  public putAgencia(idAgencia, params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_AGENCIA + "/" + idAgencia;
    return this.http.put<any>(url, params).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Agencia",
            text: "Error actualizando información de la agencia.",
            type: "error"
          });
        }
        
        return throwError(err);
      })
    );
  }

  public deleteAgencia(agencia, usuario): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_AGENCIA +
      "/" +
      agencia +
      "/" +
      usuario;
    return this.http.delete<any>(url).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Agencia",
            text: "Error eliminado información de la agencia.",
            type: "error"
          });
        }        
        return throwError(err);
      })
    );
  }
}
